export const routesRequiringClientConfigFetch = ["Secondary", "Primary", "Stocks", "Delivery", "Primary OMS"]